import "esbuild-css-modules-plugin-ns-css:src/js/pages/servicesStep/servicesStep.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/pages/servicesStep/servicesStep.module.css:injector.js";
export default new Proxy({
  "blurbContainer": "servicesStep-module__blurbContainer_58OKWq__1100",
  "blurbText": "servicesStep-module__blurbText_58OKWq__1100",
  "selectText": "servicesStep-module__selectText_58OKWq__1100",
  "stepContainer": "servicesStep-module__stepContainer_58OKWq__1100",
  "stepTitle": "servicesStep-module__stepTitle_58OKWq__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      